import {ApplicationConfig, provideZoneChangeDetection} from "@angular/core";
import {provideRouter} from "@angular/router";
import {routes} from "./app.routes";
import {provideTranslateService} from "@ngx-translate/core";
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import { IGX_INPUT_GROUP_TYPE } from '@infragistics/igniteui-angular/input-group';
import {registerLocaleData} from "@angular/common";
import localeEs from '@angular/common/locales/es-MX';
import {
  interceptorErrorHandlerInterceptor
} from "./core/interceptors/interceptor-error-handler.interceptor";
import {AppInfoService} from "./core/services/app-info.service";
import {AuthLoginService} from "./componentes/autenticacion/services/auth-login.service";
import {SocketService} from "./core/services/socket.service";
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideIgniteIntl} from '@infragistics/igniteui-angular/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideZoneChangeDetection(),
    provideAnimations(),
    provideIgniteIntl(),
    provideHttpClient(
      withInterceptors([
        interceptorErrorHandlerInterceptor
      ])
    ),
    provideTranslateService({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({prefix: "./assets/i18n/", suffix: ".json"}),
    }),
    AppInfoService,
    AuthLoginService,
    SocketService,
    {provide: IGX_INPUT_GROUP_TYPE, useValue: 'line'}
  ]
}

registerLocaleData(localeEs);
